import * as React from "react"
import { useEffect, useState } from "react"
import { getSubmit } from "@ui-seeker/utils"

import { SitesMultiSelect } from "@components"
import { BACKEND_APIS } from "@constants"
import { selectedMarkets, selectedSites, sitesOptions } from "../@signals"


/**
 * The sites. Several allowed, at least one required.
 *
 * It is what bounds the query, and everything on this screen pays for that: the
 * 335 customer/site pairs in the table run from a few hundred products to
 * 200.217, and a query without a site is the whole customer at once. Several
 * are fine — `id_site IN (…)` still walks the index prefix, one range per site.
 *
 * The market filter above only narrows this list; it never searches on its own.
 */
export default function ScrapingDataReviewSitesFilter() {
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const params = { all: 1 }
        if (selectedMarkets.value?.length > 0) {
            params.markets = selectedMarkets.value.join(',')
        }
        setIsLoading(true)
        getSubmit(`${BACKEND_APIS.SCRAPING_DATA_REVIEW}/sites`, params)
            .then(res => { if (res) sitesOptions.value = res })
            .catch(err => console.error('Error fetching sites:', err))
            .finally(() => setIsLoading(false))
    }, [selectedMarkets.value])

    return <SitesMultiSelect
        options={sitesOptions.value || []}
        value={selectedSites.value || []}
        onChange={(options) => selectedSites.value = options || []}
        loading={isLoading}
        label="Sites *"
        placeholder="Required"
        error={(selectedSites.value || []).length === 0}
    />
}
